import { FC, useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import cn from 'classnames';
import Button from 'antd/lib/button/button';
import Item from 'antd/lib/form/FormItem';
import { FormInstance } from 'antd/lib/form/hooks/useForm';
import Image from 'antd/lib/image';

import QuestionMark from 'components/QuestionMark/QuestionMark';
import { selectStoreSettings } from 'store/selectors/settingsSelectors';
import useModal from 'hooks/useModal';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { EModalsNames } from 'modals/constants';
import { formRules, questionMarks } from 'utils/constants/constants';
import errorImage from 'assets/img/images/error-image.png';

const logoContainerClasses = 'flex items-center justify-between mt-2.5 py-2.5 px-4 border border-black-20 rounded-lg '
  + 'dark:border-black-80 duration-300';
const logoErrorClasses = 'border-red-50 dark:border-red-50';

const MyStoreLogo: FC<FormInstance> = ({ getFieldsValue, setFieldsValue }) => {
  const { logoUrl } = useTypedSelector(selectStoreSettings);
  const setModal = useModal();

  useEffect(() => {
    logoUrl && setFieldsValue({ ...getFieldsValue(), logoUrl });
  }, [logoUrl]);

  return (
    <div className="mb-10">
      <Item shouldUpdate noStyle>
        {({ getFieldError }) => <Item name="logoUrl" rules={[formRules.required]}>
          <div className="required">
            Store Logo
            <QuestionMark>{questionMarks.store.logo}</QuestionMark>
          </div>
          <div className={cn(logoContainerClasses, { [logoErrorClasses]: !isEmpty(...getFieldError('logoUrl')) })}>
            <div className="flex items-center gap-2.5">
              <Image src={logoUrl || errorImage} width={54} height={54} preview={false} fallback={errorImage} />
              <p>{logoUrl ? 'Your Store Logo' : 'No Image'}</p>
            </div>
            <Button onClick={() => setModal({ modalName: EModalsNames.AddImage })}>
              {logoUrl ? 'Replace' : 'Add'} Image
            </Button>
          </div>
        </Item>}
      </Item>
    </div>
  );
};

export default MyStoreLogo;
